export const FEATURE_FLAGS = {
  LOCKED_EPISODE_UPGRADE_BENEFITS: "locked-episode-upgrade-benefits",
  NOTIFICATION_CUSTOMIZATION_POPUP: "notification-customization-popup",
  STREAK_CELEBRATION_TOAST: "streak-celebration-toast",
  SHARE_ICON_VARIANT: "share-icon-variant",
  SHARE_TEXT_EPISODE_VARIANT: "share-text-episode-variant",
  SHARE_TEXT_SERIES_VARIANT: "share-text-series-variant",
  SHARE_TEXT_HOME_VARIANT: "share-text-home-variant",
  SHARE_TEXT_GIFTING_VARIANT: "share-text-gifting-variant",
  EPISODE_SHARE_POPUP: "episode-share-popup",
  PROFILE_BIRTH_FIELDS: "profile-birth-fields",
  SHARE_DRAWER_VARIANT: "share-drawer-variant",
  HOME_CHURCH_SELECTION_DRAWER: "home-church-selection-drawer",
  PRIVACY_POLICY_POPUP: "privacy-policy-popup",
  HOME_NEW_USER_WELCOME_TILE: "home-new-user-welcome-tile",
  SING_PLUS_PAYMENT_METHOD_WARNING_MODAL: "sing-plus-payment-method-warning-modal",
  INCOGNITO_EDUCATION_BANNER: "incognito-education-banner",
  TRENDING_DEVO_ACCESS: "trending-devos-access",
  EXPLORE_SEARCH_ENABLED: "explore-search-enabled",
  HUBSPOT_SUPPORT_CHAT: "hubspot-support-chat",
  DAILY_DEVO_EMAIL_CHANNEL: "daily-devo-email-channel",
  PROMOTIONAL_SMS_OPT_IN: "promotional-sms-opt-in",
  POST_SIGNUP_SMS_OPT_IN_POPUP: "post-signup-sms-opt-in-popup",
} as const;

export const MULTIVARIATE_FLAG_CONFIG = {
  NOTIFICATION_CUSTOMIZATION_POPUP: {
    variants: ["free_content", "plus_content"] as const,
    default: "hide",
  },
  STREAK_CELEBRATION_TOAST: {
    variants: ["control", "test"] as const,
    default: "control",
  },
  SHARE_ICON_VARIANT: {
    variants: ["control", "test"] as const,
    default: "test",
  },
  SHARE_TEXT_EPISODE_VARIANT: {
    variants: ["control", "test", "test-2"] as const,
    default: "control",
  },
  SHARE_TEXT_SERIES_VARIANT: {
    variants: ["control", "test", "test-2"] as const,
    default: "control",
  },
  SHARE_TEXT_HOME_VARIANT: {
    variants: ["control", "test", "test-2"] as const,
    default: "control",
  },
  SHARE_TEXT_GIFTING_VARIANT: {
    variants: ["control", "test", "test-2"] as const,
    default: "control",
  },
  EPISODE_SHARE_POPUP: {
    variants: ["control", "test", "test-2"] as const,
    default: "control",
  },
  SHARE_DRAWER_VARIANT: {
    variants: ["control", "test"] as const,
    default: "control",
  },
  HOME_NEW_USER_WELCOME_TILE: {
    variants: ["control", "test"] as const,
    default: "control",
  },
} as const;
